import { render } from "./CalnderPage.vue?vue&type=template&id=ac632512&scoped=true"
import script from "./CalnderPage.vue?vue&type=script&lang=js"
export * from "./CalnderPage.vue?vue&type=script&lang=js"

import "./CalnderPage.vue?vue&type=style&index=0&id=ac632512&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac632512"]])

export default __exports__